<template>
  <div class="store-detail">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.visitSellIn')">
      <div class="right-header" v-if="paramsUrl.pageType !== 'unassignedStore' && visitInfo.isEdit" @click="toPage(`/storeExpansion/visitSellIn?visitId=${visitInfo.id}&customerId=${visitInfo.customerId}`)">
        {{ $t('button.edit') }}
      </div>
      <div class="right-ignore-header" v-if="visitInfo.customerAllot && paramsUrl.pageType === 'unassignedStore' && visitInfo.customerAllot.status === 0" @click="handleOper">
        {{ $t('button.ignore') }}
      </div>
    </NavHeaderBar>
    <div class="detail-main-content">
      <div class="mark-info"><span>{{ visitInfo.customerName }}</span></div>
      <div class="info">
        <div class="item-title">{{ $t('form.visitInfo') }}.</div>
        <div class="item-info">
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.name') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.createUserName }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.visitDate') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.visitTime }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.checkInPhoto') }}</span>
            <span class="right" v-if="visitInfo.imgMap && visitInfo.imgMap.check">
              <img class="photo-img" :src="visitInfo.imgMap.check" alt="" @click="imgPreview(0, visitInfo.imgMap.check)">
            </span>
          </div>
        </div>
      </div>
      <div class="info" v-if="isShowSellIn">
        <div class="item-title">{{ $t('form.listingStatus') }}</div>
        <div class="item-info">
          <div class="top-title">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.productListingStatus') }}</div>
            </div>
          </div>
          <div class="brand-section" v-for="(brandItem, brandIndex) in visitInfo.shelfList" :key="brandIndex">
            <div class="product-section" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <div class="brand-title square">
                <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }} · {{ subItem.productName }}</span>
                <span class="custom-font" :class="{'end-of-sales': subItem.isShelf === -1}">{{ subItem.isShelf === 1 ? $t('form.listing') : subItem.isShelf === 0 ? $t('form.notListing') : subItem.isShelf === -1 ? $t('form.endOfSales') : '' }}</span>
              </div>
              <div v-if="subItem.isShelf === 1" class="quantity-content">
                <div class="qt-item" :class="{'jin': detaItem.isChoose}" v-for="(detaItem, detaIndex) in subItem.detailList" :key="detaIndex">
                  <span v-if="detaItem.isChoose">{{ detaItem.type }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="top-title" v-if="isShowSd">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.listingProductSupplierDistributor') }}</div>
            </div>
          </div>
          <div class="brand-section" v-for="(brandItem, brandIndex) in visitInfo.shelfList" :key="brandIndex + 'a'">
            <div class="brand-title square" v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
              <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }}</span>
            </div>
            <div class="quantity-content" v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
              <div class="qt-item jin" v-for="(detaItem, detaIndex) in brandItem.expandInfo.sdList" :key="detaIndex">
                <span>{{ detaItem.sdName }}</span>
              </div>
              <div class="qt-item jin" v-if="brandItem.expandInfo.otherSd">
                <span>{{ $t('form.other') }}：{{ brandItem.expandInfo.otherSd }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="visitInfo.expandOrder && ![null, ''].includes(visitInfo.expandOrder.isDirect)">
        <div class="item-title">{{ $t('form.sellInByMyselfThisTime') }}</div>
        <div class="item-info">
          <!-- v-if="checkPer(['admin', 'app:expand:direct'])" -->
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.directOrNot') }}：</span>
            <span v-if="!['', null].includes(visitInfo.expandOrder.isDirect)" class="right custom-font txt-ellipsis">{{ visitInfo.expandOrder.isDirect ? $t('form.sellInFromAcmefog') : $t('form.sellInFromDistributor') }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.firstTimeOrNot') }}：</span>
            <span v-if="!['', null].includes(visitInfo.expandOrder.firstOrder)" class="order-type">{{ visitInfo.expandOrder.firstOrder === 1 ? $t('form.firistOrder') : visitInfo.expandOrder.firstOrder === 0 ? $t('shared.reorder') : '' }}</span>
          </div>
          <div class="is-Direct" v-if="visitInfo.expandOrder.isDirect">
            <div class="top-title">
              <div class="right-title">
                <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
                <div style="color: #317bff;">{{ $t('form.quantitySoldPcs') }}</div>
              </div>
              <div>{{ $t('form.total') }}：<span class="custom-font">{{ totalProductQuantity }}</span> {{ $t('form.pcs') }}</div>
            </div>
            <div v-for="(brandItem, brandIndex) in visitInfo.expandOrder.productList" :key="brandIndex">
              <div class="custom-section section-quantity" v-if="brandItem.totalSpec > 0">
                <!-- :class="{'custom-collapse': !subItem.activeNames.includes('1')}" -->
                <div class="section-title square">
                  <span style="flex: 1;">{{ brandItem.projectName }}</span>
                  <span>{{ $t('form.total') }}：<span class="custom-font">{{ brandItem.totalSpec }}</span> {{ $t('form.pcs') }}</span>
                </div>
                <van-collapse v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex" v-model="subItem.activeNames" :class="{'custom-collapse': !subItem.activeNames.includes('1')}">
                  <van-collapse-item title="" name="1">
                    <template #title>
                      <div class="collapse-title">
                        <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                        <span>{{ subItem.productName }}：</span>
                        <span><span class="custom-font">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</span>
                      </div>
                    </template>
                    <div class="spec-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                      <div class="quantity-item">
                        {{ specItem.specName }}：<span>{{ specItem.quantity }}</span>
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </div>
            <div class="top-title">
              <div class="right-title">
                <img class="ell-icon" src="@/assets/images/ell_custom_icon.png" alt="">
                <div style="color: #808000;">{{ $t('form.quantityGivenAwayPcs') }}</div>
              </div>
              <div>{{ $t('form.total') }}：<span class="custom-font" style="color: #808000;">{{ totalGiveProductQuantity }}</span> {{ $t('form.pcs') }}</div>
            </div>
            <div v-for="(brandItem, brandIndex) in visitInfo.expandOrder.giveProductList" :key="brandIndex + '1'">
              <div class="custom-section section-quantity" v-if="brandItem.totalSpec > 0">
                <div class="section-title custom-ection-title square">
                  <span style="flex: 1;">{{ brandItem.projectName }}</span>
                  <span>{{ $t('form.total') }}：<span class="custom-font" style="color: #808000;">{{ brandItem.totalSpec }}</span> {{ $t('form.pcs') }}</span>
                </div>
                <van-collapse v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex" v-model="subItem.activeNames" :class="{'custom-collapse': !subItem.activeNames.includes('1')}">
                  <van-collapse-item title="" name="1">
                    <template #title>
                      <div class="collapse-title">
                        <img class="jt-icon" src="@/assets/images/jt_custom_icon.png" alt="">
                        <span>{{ subItem.productName }}：</span>
                        <span><span class="custom-font" style="color: #808000;">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</span>
                      </div>
                    </template>
                    <div class="spec-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                      <div class="quantity-item custom-quantity-item">
                        {{ specItem.specName }}：<span>{{ specItem.quantity }}</span>
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="custom-section" v-for="(brandItem, brandIndex) in visitInfo.expandOrder.reorderList" :key="brandIndex">
              <div class="section-title square">
                <span style="flex: 1;">{{ brandItem.projectName }}</span>
                <span>{{ $t('form.total') }}：<span class="custom-font">{{ allProdctPcs(brandItem, 'reorderList') }}</span> {{ $t('form.pcs') }}</span>
              </div>
              <div v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                <div class="product-item">
                  <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                  <div>{{ subItem.productName }}：<span class="custom-font">{{ calculateNum(subItem.quantity, subItem.giveQuantity) }} </span>{{ $t('form.pcs') }}</div>
                </div>
                <div class="section-product-sell">
                  <div class="sell-in-item">
                    <div class="quantity-item">
                      {{ $t('form.quantitySoldPcs') }}：<span>{{ subItem.quantity ? subItem.quantity : $t('shared.filter.unknown') }}</span>
                    </div>
                    <div class="quantity-item">
                      {{ $t('form.quantityGivenAwayPcs') }}：<span>{{ subItem.giveQuantity ? subItem.giveQuantity : $t('shared.filter.unknown') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
                <div class="product-item">
                  <img class="sd-icon" src="@/assets/images/ell_sd.png" alt="">
                  <div>{{ $t('form.brandSupplierDistributor') }}</div>
                </div>
                <div class="section-product-sell">
                  <div class="sell-in-item">
                    <div class="quantity-item" v-for="(sdItem, sdIndex) in brandItem.expandInfo.sdList" :key="sdIndex">
                      {{ sdItem.sdName }}
                    </div>
                    <div class="quantity-item" v-if="brandItem.expandInfo.otherSd">
                      {{ $t('form.other') }}：{{ brandItem.expandInfo.otherSd }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="visitInfo.expandOrder.isDirect">
            <!-- <div class="item-section">
              <span class="left">Order Type</span>
              <span class="right txt-ellipsis custom-font">{{ visitInfo.expandOrder.orderType }}</span>
            </div> -->
            <div class="item-section">
              <span class="left">{{ $t('form.paymentType') }}</span>
              <span class="right txt-ellipsis custom-font">{{ visitInfo.expandOrder.paymentType }}</span>
            </div>
            <div class="item-section">
              <span class="left">{{ $t('form.paymentStatus') }}</span>
              <span class="right txt-ellipsis custom-font">{{ visitInfo.expandOrder.paymentStatus }}</span>
            </div>
            <div class="item-section">
              <span class="left">{{ $t('form.tax') }}</span>
              <span class="right txt-ellipsis custom-font">{{ visitInfo.expandOrder.taxType }}</span>
            </div>
          </div>
          <div class="custom-section" v-if="visitInfo.isSellInBa && visitInfo.imgMap && (visitInfo.imgMap.poOrder || visitInfo.imgMap.receipt || visitInfo.imgMap.productCashOrCheque)">
            <div class="left img-left txt-ellipsis section-title square">{{ $t('form.sellInPhoto') }}</div>
            <div class="sell-in-photo">
              <!-- <img v-for="(subItem, subIndex) in visitInfo.imgMap.servicePhoto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt=""> -->
              <div class="photo-item" v-if="visitInfo.imgMap.poOrder">
                <span class="item-left">{{ $t('form.pOOrder') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.poOrder.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.poOrder)">
                </span>
              </div>
              <div class="photo-item" v-if="visitInfo.imgMap.receipt">
                <span class="item-left">{{ $t('form.receipt') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.receipt.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.receipt)">
                </span>
              </div>
              <div class="photo-item" v-if="visitInfo.imgMap.productCashOrCheque">
                <span class="item-left">{{ $t('form.productCashCheque') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.productCashOrCheque.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.productCashOrCheque)">
                </span>
              </div>
            </div>
          </div>
          <div v-if="historyList.length > 0" class="custom-section">
            <div class="section-title square">
              <span style="flex: 1;">{{ $t('form.orderModificationHistory') }}</span>
              <span class="total-desc" @click="toPage(`/shared/orderUpdate?sourceId=${paramsUrl.visitId}&sourceType=0&moduleType=${!visitInfo.expandOrder.isDirect ? 2 : 1}`)">{{ $t('shared.more') }} ></span>
            </div>
            <div class="history-info">
              <div class="time-name">{{ historyList[0].localCreateTime }} {{ historyList[0].createUserName }}</div>
              <div class="reason-info">
                <span class="reason-text">{{ $t('form.editReason') }}：</span>
                <span>{{ historyList[0].remark }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="sampleListTotal > 0 || materialListTotal > 0 || (visitInfo.imgMap && visitInfo.imgMap.deliveryMaterialProto)">
        <div class="item-title">{{ $t('form.materialSampleDelivery') }}</div>
        <div class="item-info is-Direct" v-if="sampleListTotal > 0">
          <div class="product-title square">
            <div class="left-desc">{{ $t('form.sampleDelivery') }}</div>
            <div class="right">{{ $t('form.total') }} <span class="custom-font">{{ sampleListTotal }}</span> {{ $t('form.pcs') }}</div>
          </div>
          <div class="material-delivey" v-if="sampleList.length > 0">
            <div class="material-item" v-for="subItem in sampleList" :key="subItem.id">
              {{ subItem.projectName }}·{{ subItem.productName }}：{{ subItem.quantity }}
            </div>
          </div>
        </div>
        <div class="item-info is-Direct" v-if="materialListTotal > 0">
          <div class="product-title square">
            <div class="left-desc">{{ $t('form.materialDelivery') }}</div>
            <div class="right">{{ $t('form.total') }} <span class="custom-font">{{ materialListTotal }}</span> {{ $t('form.pcs') }}</div>
          </div>
          <div class="material-delivey">
            <div class="material-item" v-for="subItem in putMaterielList" :key="subItem.id">
              {{ subItem.materielName }}：{{ subItem.quantity }}
            </div>
          </div>
        </div>
        <div class="img-content" v-if="visitInfo.imgMap && visitInfo.imgMap.deliveryMaterialProto">
          <div class="img-imgMap-left">{{ $t('form.materialSamplePhoto') }}</div>
          <div class="img-right">
            <img v-for="(subItem, subIndex) in visitInfo.imgMap.deliveryMaterialProto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.deliveryMaterialProto)">
          </div>
        </div>
      </div>
      <div class="info">
        <div class="item-title">{{ $t('form.kOSGroupInvitation') }}</div>
        <div class="item-info">
          <div class="item-section" v-if="visitInfo.invite">
            <span class="left txt-ellipsis">{{ $t('form.staffName') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.invite.staffName }}</span>
          </div>
          <div class="custom-section" v-if="visitInfo.imgMap && (visitInfo.imgMap.inviteUrl)">
            <div class="sell-in-photo">
              <div class="photo-item custom-photo-item">
                <span class="item-left">{{ $t('form.kOSGroupJoinScreenshot') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.inviteUrl.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.inviteUrl)">
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="item-title">{{ $t('form.recommendationsEventInvitations') }}</div>
        <div class="item-info">
          <div class="item-section">
            <span class="left">{{ $t('form.recommendedForRoutineOperation') }}</span>
            <span class="right txt-ellipsis custom-font">{{ visitInfo.isCommend === 1 ? $t('shared.filter.yes') : $t('shared.filter.no') }}</span>
          </div>
          <div class="invitation-info" v-if="visitInfo.visitEvent && visitInfo.visitEvent.isEvent == 1 && visitInfo.isCommend === 1">
            <div class="invitation-title square">{{ $t('form.invitationsInfo') }}.</div>
            <div class="item-section">
              <span class="left">{{ $t('form.eventStoreContactName') }}</span>
              <span class="right">{{ visitInfo.visitEvent.contactName }}</span>
            </div>
            <div class="item-section">
              <span class="left txt-ellipsis">{{ $t('form.contactPosition') }}</span>
              <span class="right txt-ellipsis">{{ visitInfo.visitEvent.job }}</span>
            </div>
            <div class="item-section">
              <span class="left txt-ellipsis">{{ $t('form.phoneNumber') }}</span>
              <span class="right txt-ellipsis">{{ visitInfo.visitEvent.contactPhone }}</span>
            </div>
            <div class="item-section">
              <span class="left txt-ellipsis">{{ $t('form.expectedTime') }}</span>
              <span class="right txt-ellipsis">{{ visitInfo.visitEvent.expectedTime }}</span>
            </div>
            <div class="item-section">
              <span class="left txt-ellipsis">{{ $t('form.notes') }}</span>
              <span class="right txt-ellipsis">{{ visitInfo.visitEvent.note }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="visitInfo.feedback">
        <div class="item-title">{{ $t('shared.feedback') }}</div>
        <div class="item-info">
          <div class="item-section">
            {{ visitInfo.feedback }}
          </div>
        </div>
      </div>
    </div>
    <div class="oper-bottom-btn" v-if="visitInfo.customerAllot && paramsUrl.pageType === 'unassignedStore' && visitInfo.customerAllot.status === 0">
      <van-button class="left-btn" @click="toPage(`/storeExpansion/storeMappingDetail?customerId=${visitInfo.customerId}`)">{{ $t('button.storeInfo') }}</van-button>
      <van-button class="right-btn" @click="toPage(`/unassignedStore/transferAssign?assignId=${visitInfo.customerAllot.id}`)">{{ $t('button.assign') }}</van-button>
    </div>
  </div>
</template>

<script>
import { arsVisitInfoApi } from '@/api/visit'
import { changeListPageApi } from '@/api/shared'
import { customerAllotIgnoreAllotApi } from '@/api/unassignedStore'
import { calculateAdd } from '@/utils/math'
import { ImagePreview, Toast, Dialog, Notify } from 'vant'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      paramsUrl: {},
      visitInfo: {},
      putMaterielList: [],
      sampleList: [],
      historyList: []
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.getVisitInfo()
  },
  deactivated () {
    this.$destroy()
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    totalProductQuantity () {
      if (!this.visitInfo.expandOrder || !this.visitInfo.expandOrder.productList) {
        return 0
      }
      return this.visitInfo.expandOrder.productList.reduce((acc, curr) => acc + Number(curr.totalSpec), 0)
    },
    totalGiveProductQuantity () {
      if (!this.visitInfo.expandOrder || !this.visitInfo.expandOrder.giveProductList) {
        return 0
      }
      return this.visitInfo.expandOrder.giveProductList.reduce((acc, curr) => acc + Number(curr.totalSpec), 0)
    },
    materialListTotal () {
      return this.putMaterielList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    sampleListTotal () {
      return this.sampleList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    isShowSellIn () {
      if (!this.visitInfo.shelfList || this.visitInfo.shelfList.length === 0) {
        return false
      }
      return this.visitInfo.shelfList.some(brandItem => {
        return brandItem.productList.length > 0
      })
    },
    isShowSd () {
      if (!this.visitInfo.shelfList || this.visitInfo.shelfList.length === 0) {
        return false
      }
      return this.visitInfo.shelfList.some(brandItem => {
        return brandItem.expandInfo.sdList.length > 0 || !['', null].includes(brandItem.expandInfo.otherSd)
      })
    }
  },
  methods: {
    getVisitInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsVisitInfoApi(this.paramsUrl.visitId).then(res => {
        Toast.clear()
        const { putMaterielList, expandOrder, protoList, imgMap, shelfList } = res.data
        expandOrder.productList.forEach(brandItem => {
          let totalSpec = 0
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
            subItem.specList = subItem.specList.filter(specItem => {
              return !['', null].includes(specItem.quantity)
            })
            totalSpec += subItem.specList.reduce((sum, specItem) => {
              return sum + (specItem.quantity ? Number(specItem.quantity) : 0)
            }, 0)
          })
          brandItem.totalSpec = totalSpec
        })
        expandOrder.giveProductList.forEach(brandItem => {
          let totalSpec = 0
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
            subItem.specList = subItem.specList.filter(specItem => {
              return !['', null].includes(specItem.quantity)
            })
            totalSpec += subItem.specList.reduce((sum, specItem) => {
              return sum + (specItem.quantity ? Number(specItem.quantity) : 0)
            }, 0)
          })
          brandItem.totalSpec = totalSpec
        })
        expandOrder.reorderList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        shelfList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        this.putMaterielList = putMaterielList.filter(subItem => {
          return subItem.quantity > 0
        })
        this.sampleList = protoList.filter(subItem => {
          return subItem.quantity > 0
        })
        this.visitInfo = res.data
        if (expandOrder && expandOrder.isDirect) {
          this.visitInfo.imgMap.poOrder = imgMap.directPoOrder
          this.visitInfo.imgMap.receipt = imgMap.directReceipt
          this.visitInfo.imgMap.productCashOrCheque = imgMap.directProductCashOrCheque
        } else {
          this.visitInfo.imgMap.poOrder = imgMap.poOrder
          this.visitInfo.imgMap.receipt = imgMap.receipt
          this.visitInfo.imgMap.productCashOrCheque = imgMap.productCashOrCheque
        }
        const data = {
          sourceId: this.paramsUrl.visitId,
          sourceType: 0,
          moduleType: !this.visitInfo.expandOrder.isDirect ? 2 : 1
        }
        changeListPageApi(data).then(res => {
          this.historyList = res.data.list
        })
      }).catch(() => {})
    },
    imgPreview (index, url) {
      ImagePreview({
        images: url.split(','),
        startPosition: index
      })
    },
    getlocation (params) {
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${params.address}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    toPage (url) {
      if (!url) {
        return
      }
      this.$router.push(url)
    },
    calculateNum (num1, num2) {
      return calculateAdd(num1, num2)
    },
    allProdctPcs (params = {}) {
      if (params.productList.length > 0) {
        return params.productList.reduce((acc, curr) => acc + this.calculateNum(curr.quantity, curr.giveQuantity), 0)
      }
      return 0
    },
    handleOper () {
      // 移除后，在BA重新提交之前该门店不会出现在待分配列表中
      Dialog.confirm({
        message: this.$t('tips.messageFortyFour'),
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#323233'
      })
        .then(() => {
          customerAllotIgnoreAllotApi({ id: this.visitInfo.customerAllot.id }).then(res => {
            Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
            this.$router.go(-1)
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang="less" scoped>
.store-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  .right-header {
    font-size: 14px;
    color: #307bff;
  }
  .right-ignore-header {
    font-size: 14px;
    color: #c4200b;
  }
  .detail-main-content {
    flex: 1;
    overflow-y: auto;
  }
  .mark-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px;
    font-weight: 700;
    color: #555;
    >span {
      font-size: 14px;
    }
    >span:nth-child(2) {
      margin-top: 5px;
    }
  }
  .info {
    margin-bottom: 20px;
    .item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #307bff;
      &::before {
        content: '';
        width: 6px;
        height: 12px;
        margin-right: 3px;
        background-color: #307bff;
      }
    }
    .item-info {
      padding: 0px 12px;
      .top-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        color: #333;
        font-size: 12px;
        margin-top: 10px;
        .right-title {
          display: flex;
          align-items: center;
        }
        .ell-icon {
          width: 11px;
          height: 11px;
          margin-right: 5px;
        }
      }
      .item-section {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .left {
          width: 206px;
          margin-right: 5px;
          word-break: break-word;
        }
        .right {
          flex: 1;
          text-align: right;
          word-break: break-word;
        }
        .order-type {
          max-width: 80px;
          padding: 3px 6px;
          text-align: center;
          border: 1px solid #307bff;
          background-color: #e8effc;
          color: #307bff;
        }
        .img-left {
          width: 126px;
        }
        .img-right {
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
        }
      }
      .custom-section {
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .img-left {
          width: 126px;
          padding-left: 1px;
        }
        .img-right {
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;
        }
        .section-product-sell {
          padding: 10px;
          background-color: #f7f7f7;
          margin-top: 8px;
          border-radius: 8px;
          .sell-in-item {
            margin-bottom: 8px;
            color: #7f7f7f;
            &:last-child {
              margin-bottom: 0;
            }
            .quantity-item {
              margin-bottom: 6px;
              &:last-child {
                margin-bottom: 0;
              }
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
        }
        .product-item {
          display: flex;
          align-items: center;
          padding-top: 10px;
        }
        .history-info {
          padding: 10px;
          margin-top: 8px;
          border-radius: 8px;
          background-color: #f7f7f7;
          color: #333;
          .time-name {
            margin-bottom: 6px;
          }
          .reason-info {
            word-break: break-word;
          }
          .reason-text {
            color: #307bff;
            font-weight: bold;
          }
        }
      }
      .section-quantity {
        padding-left: 5px;
      }
      .section-title,
      .brand-title,
      .product-title {
        display: flex;
        align-items: center;
        color: #333;
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
        .total-desc {
          font-weight: 400;
        }
      }
      .custom-ection-title {
        &.square {
          &::before {
            background-color: #808000;
          }
        }
      }
      .product-title {
        padding-top: 16px;
        color: #333;
        .left-desc {
          flex: 1;
          font-weight: bold;
        }
      }
      .sell-in-photo {
        .photo-item {
          display: flex;
          justify-content: space-between;
          padding: 10px 12px;
          border-bottom: 1px solid #e8effc;
          &:last-child {
            border-bottom: none;
          }
          .item-left {
            width: 126px;
          }
          .item-right {
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
          }
        }
        .custom-photo-item {
          padding: 10px 0;
        }
      }
      .invitation-info {
        .invitation-title {
          display: flex;
          align-items: center;
          padding-top: 16px;
          padding-bottom: 6px;
          &.square {
            font-weight: bold;
            &::before {
              content: '';
              width: 8px;
              height: 8px;
              background-color: #307bff;
              // position: absolute;
              // left: 0;
              // top: 0;
              transform: rotate(45deg);
              margin-right: 5px;
            }
          }
        }
      }
      .brand-section {
        .product-section {
          border-bottom: 1px solid #e8effc;
        }
        .brand-title {
          padding: 10px 0;
        }
        .quantity-content {
          padding: 10px;
          background-color: #f7f7f7;
          border-radius: 8px;
          margin-bottom: 5px;
          .qt-item {
            color: #7f7f7f;
            word-break: break-word;
            &.jin {
              margin-bottom: 8px;
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .img-content {
      padding: 10px;
      padding-bottom: 0;
      .img-imgMap-left {
        margin-bottom: 5px;
      }
    }
    .is-Direct {
      .section-product-sell {
        margin-top: 0px !important;
      }
      .custom-section {
        padding-bottom: 5px;
      }
      .spec-item {
        margin-bottom: 8px;
        color: #7f7f7f;
        &:last-child {
          margin-bottom: 0;
        }
        .quantity-item {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
          &::before {
            content: '#';
            width: 8px;
            height: 8px;
            color: #307bff;
            margin-right: 5px;
          }
        }
        .custom-quantity-item {
          &::before {
            color: #808000;
          }
        }
      }
      .collapse-title {
        display: flex;
        align-items: center;
        padding: 5px 0px;
      }
      /deep/.van-collapse {
        .van-collapse-item__title {
          padding: 0;
          font-size: 12px;
          margin-bottom: 0;
        }
        .van-collapse-item__title--expanded::after {
          display: none;
        }
        .van-collapse-item__content {
          padding: 10px;
          font-size: 12px;
          background-color: #f7f7f7;
          border-radius: 10px;
        }
        .van-cell__right-icon {
          right: 10px;
          top: 5px;
        }
      }
      /deep/.van-hairline--top-bottom::after {
        display: none;
      }
      .custom-collapse {
        /deep/.van-collapse-item__title {
          border-radius: 10px;
        }
      }
    }
    .material-delivey {
      padding: 10px;
      background-color: #f7f7f7;
      margin-top: 8px;
      border-radius: 8px;
      color: #7f7f7f;
      .material-item {
        margin-bottom: 6px;
        &:last-child {
          margin-bottom: 0;
        }
        &::before {
          content: '#';
          width: 8px;
          height: 8px;
          color: #307bff;
          margin-right: 5px;
        }
      }
    }
    .end-of-sales {
      color: #c4200b;
    }
    .jt-icon {
      width: 9px;
      height: 12px;
      margin-right: 5px;
    }
    .sd-icon {
      width: 10px;
      height: 9px;
      margin-right: 5px;
    }
  }

  .photo-img {
    width: 60px;
    height: 60px;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
  }
  .custom-font {
    font-weight: bold;
    color: #307bff;
  }
}
.work-dialog {
  overflow: visible;
  /deep/.van-dialog__header {
    font-weight: bold;
  }
  .close-btn-wrapper {
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
